<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}Person`"
  [size]="980"
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
>
  @let form = data.contactPerson;
  <form [formGroup]="form" [onyxAutoFocus]="data.mode">
    @let controls = form.controls;
    <div class="group">
      <onyx-text-field
        [formControl]="controls.firstName"
        label="labels.firstName"
        textTransform="titlecase"
      ></onyx-text-field>

      <onyx-text-field
        [formControl]="controls.lastName"
        label="labels.lastName"
        textTransform="titlecase"
      ></onyx-text-field>

      <onyx-dropdown
        [formControl]="controls.roles"
        label="labels.roles"
        [options]="roles$ | async"
        [multiple]="true"
      ></onyx-dropdown>
    </div>

    <div class="group">
      <onyx-text-field
        [formControl]="controls.email"
        label="labels.email"
        textTransform="lowercase"
      ></onyx-text-field>

      <onyx-phone-number-input
        [formControl]="controls.phone"
        label="labels.phone"
      ></onyx-phone-number-input>
    </div>

    <div class="group">
      <onyx-text-field
        [formControl]="controls.transId"
        label="ID Trans"
      ></onyx-text-field>

      <onyx-text-field
        [formControl]="controls.timocomId"
        label="ID Timocom"
      ></onyx-text-field>

      <onyx-text-field
        [formControl]="controls.note"
        label="labels.note"
      ></onyx-text-field>
    </div>
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="cancel()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button (click)="submit()">
      {{
        (data.mode === OnyxFormMode.ADD ? 'labels.add' : 'labels.saveChanges')
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
